import { Routes } from '@angular/router';

export const AIRCRAFT_ROUTES: Routes = [
  { path: ':id', loadComponent: async () => (await import('./components/aircraft-view/aircraft-view.component')).AircraftViewComponent },
  { path: '', loadComponent: async () => (await import('./components/aircraft-list/aircraft-list.component')).AircraftListComponent }
];
